// MARK: Types

export type AffiliateApplication = {
  application: AffiliateApplicationAttributeApplication
  location: AffiliateApplicationAttributeLocation
  insurance: AffiliateApplicationAttributeInsurance
  payment: AffiliateApplicationAttributePayment
  license: AffiliateApplicationAttributeLicense
  activation: AffiliateApplicationAttributeActivation
  userId: number
}

export type AffiliateCompetitionRecord = {
  name: string
  competitionRecordId: number
  competition: {
    id: number
    identifier: string
    type: string
    year: number
    name: string
    leaderboardMode: string
    slug: string
    active: boolean
    featured: boolean
    ageCutoffDate: string
    startDate: string
    endDate: string
    registrationStartDate: string
    registrationEndDate: string
    profileEditStartDate?: string
    profileEditEndDate?: string
    scoresFinalizedDate?: string
  }
  region?: {
    id: number
    name: string
  }
  country: {
    code: string
    name: string
  }
}

// MARK: Enums

export enum AffiliateApplicationAttributeApplication {
  STARTED = 'Started',
  SUBMITTED = 'Submitted',
  GET_A_NAME = 'Get a Name',
  NAME_PENDING = 'Name Pending',
  DONE = 'Done',
}

export enum AffiliateApplicationAttributeLocation {
  REQUEST_UPDATE = 'Request Update',
  SUBMITTED = 'Submotted',
  PENDING_HQ = 'Pending HQ',
  DONE = 'Done',
}

export enum AffiliateApplicationAttributeInsurance {
  GET_INSURED = 'Get Insured',
  REQUEST_UPDATE = 'Request Update',
  PENDING_HQ = 'Pending HQ',
  DONE = 'Done',
  NOT_REQUIRED = 'Not Required',
  COVERED_BY_HQ = 'Covered by HQ',
}

export enum AffiliateApplicationAttributePayment {
  MAKE_PAYMENT = 'Make a Payment',
  PEDNING = 'Pending',
  PROCESSING = 'Processing',
  DONE = 'Done',
  FEES_WAIVED = 'Fees Waived',
}

export enum AffiliateApplicationAttributeLicense {
  PROCESSING = 'Processing',
  SENDING = 'Sending',
  PENDING_HQ = 'Pending HQ',
  SIGN = 'Sign',
  DONE = 'Done',
}

export enum AffiliateApplicationAttributeActivation {
  PROCESSING = 'Processing',
  COMPLETED = 'Completed',
  REJECTED = 'Rejected',
  WITHDRAWN = 'Withdrawn',
  TERMINATED = 'Terminated',
}
